export default "__VITE_ASSET__CqqBx1wM__"